<template>
    <MainContent title="Crear categoría">
        <Card>
            <CategoriaForm
                :initial-data="null"
                submit-label="Guardar"
                :loading="loading"
                @submit="handleSubmit"
            />
        </Card>
    </MainContent>
</template>

<script setup>
    import { useCrearCategoria } from '@/composables/admin/bases/useCrearCategoria'
    import MainContent from '@/modules/admin/ui/MainContent.vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import CategoriaForm from '../components/CategoriaForm.vue'

    const { loading, save, saveError } = useCrearCategoria()

    async function handleSubmit(formData) {
        await save(formData)
    }
</script>
